var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"80%","margin":"0 10%"}},[_vm._m(0),_c('div',{staticClass:"back"},[_c('div',{staticClass:"back-button",on:{"click":function($event){return _vm.$router.back(-1)}}},[_vm._v(" 返回列表 ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-content"},[_c('video',{staticClass:"video-box video-js",attrs:{"id":"myVideo"}})])
}]

export { render, staticRenderFns }